import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800/50 bg-zinc-950 py-12 mt-20 relative z-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="font-bold tracking-widest text-zinc-100 mb-2">
              BSMC<span className="text-cyan-500">.AUTOS</span>
            </div>
            <p className="text-xs text-zinc-500 leading-relaxed">
              Digital Vehicle Configurator. Sovereign execution for the AI highway.
            </p>
          </div>
          <div>
            <div className="text-xs text-amber-400 uppercase tracking-widest mb-2">Operator</div>
            <p className="text-xs text-zinc-500 leading-relaxed">
              Hammurabi Coding Company, LLC<br />
              Eau Claire, WI
            </p>
          </div>
          <div>
            <div className="text-xs text-amber-400 uppercase tracking-widest mb-2">Signal</div>
            <div className="flex items-center gap-4 text-zinc-600">
              <a href="#" className="hover:text-cyan-400 transition-colors"><SafeIcon icon={FiIcons.FiTwitter} /></a>
              <a href="#" className="hover:text-cyan-400 transition-colors"><SafeIcon icon={FiIcons.FiGithub} /></a>
              <a href="#" className="hover:text-cyan-400 transition-colors"><SafeIcon icon={FiIcons.FiGlobe} /></a>
            </div>
          </div>
        </div>
        <div className="pt-6 border-t border-zinc-800/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-[10px] text-zinc-600 tracking-widest uppercase">
            © {new Date().getFullYear()} // Sovereign Highway // Telemetry: ZERO
          </div>
          <div className="text-xs text-amber-400 italic text-glow-amber">
            Keep the faith, the good exists.
          </div>
        </div>
      </div>
    </footer>
  );
}